import { render } from "./FormFloorDetailsView.vue?vue&type=template&id=0f54a400"
import script from "./FormFloorDetailsView.vue?vue&type=script&lang=js"
export * from "./FormFloorDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__